import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var AssetPdfIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13l0,2l-12,0l0,-2l12,0Zm-7,-3l0,2l-5,0l0,-2l5,0Zm7,-3l0,5l-6,0l0,-5l6,0Zm-7,0l0,2l-5,0l0,-2l5,0Zm7,-4l0,3l-12,0l0,-3l12,0Z"
  }));
});
AssetPdfIcon.displayName = 'AssetPdfIcon';
export default AssetPdfIcon;